export enum ImportedInvoicePaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
}
